var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1733,
    height: 601,
    viewBox: "0 0 1733 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_951_11)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1733,
    height: 601,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_951_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_951_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 452,
    y: -8,
    width: 1692,
    height: 518
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452 509.174L2144 509.174V-7.82617L452 -7.82617L452 509.174Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_951_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.59 -35.0002C492.8 44.0108 588.43 197.31 682.2 270.49C1029.76 541.168 1186.25 238.544 1748.48 474.883C2104.94 624.721 2154.04 235.696 2142.27 -33.8522L430.59 -35.0002Z",
    fill: "#5864FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M695.485 -207.434C654.085 -21.7231 791.944 40.543 923.512 136.833C1179.06 323.457 1293.77 146.689 1707.15 309.633C2120.54 472.577 1971.73 -207.438 1971.73 -207.438L695.485 -207.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2108.32 -207.433C2149.72 -21.7232 2011.86 40.5438 1880.29 136.833C1624.74 323.456 1510.03 146.689 1096.65 309.637C683.261 472.585 832.077 -207.433 832.077 -207.433L2108.32 -207.433Z",
    fill: "url(#paint0_linear_951_11)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_951_11",
    x1: 1335.16,
    y1: 520.86,
    x2: 1336.73,
    y2: -109.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5864FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_951_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1733,
    height: 601,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_951_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1692,
    height: 517,
    fill: "white",
    transform: "matrix(1 0 0 -1 452 517)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg1);
export default __webpack_public_path__ + "static/media/footer-bg-1.6ead602370bea53d7dc89a5d893dee05.svg";
export { ForwardRef as ReactComponent };